import { fetchApi } from "../dataAccess";
import { EcrfDataManagement } from "types/ecrf/EcrfDataManagement";
import { PagedCollection } from "types/collection";

export const getEcrfDataManagementsPath = (page?: string | string[] | undefined) =>
  `/api/ecrf_data_managements${typeof page === "string" ? `?page=${page}` : ""}`;

export const getEcrfDataManagements = (page?: string | string[] | undefined) => async () =>
  await fetchApi<PagedCollection<EcrfDataManagement>>(getEcrfDataManagementsPath(page), { cache: "no-cache" });

export default { getEcrfDataManagements, getEcrfDataManagementsPath };